import store from 'store'
import { now } from 'lodash'
import { LOCAL_STORAGE_KEYS } from '../common/consts'

export default function trackFirstVisit() {
    if (!store.get(LOCAL_STORAGE_KEYS.FIRST_VISIT)) {
        store.set(LOCAL_STORAGE_KEYS.FIRST_VISIT, now())
    }
}
